/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Payments: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="payments" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1303.3333333333333 513.9666666666667L902.7 113.3333333333335L662.4333333333333 354.1666666666668L742.3333333333333 434.0666666666667L902.7 273.7000000000001L1223.4333333333332 593.8666666666667L1303.3333333333333 513.9666666666667zM1133.3333333333333 1133.3333333333333C1196.2333333333333 1133.3333333333333 1246.6666666666665 1082.9 1246.6666666666665 1020V680H226.6666666666667V340H566.6666666666666V226.6666666666668H113.3333333333333L113.9 1020C113.9 1082.9 163.7666666666667 1133.3333333333333 226.6666666666667 1133.3333333333333H1133.3333333333333zM226.6666666666667 1020V906.6666666666669H1133.3333333333333V1020H226.6666666666667z" : "M1042.6666666666667 411.1733333333333L722.16 90.6666666666666L529.9466666666667 283.3333333333333L593.8666666666667 347.2533333333334L722.16 218.9599999999999L978.7466666666666 475.0933333333332L1042.6666666666667 411.1733333333333zM906.6666666666669 906.6666666666666C956.9866666666666 906.6666666666666 997.3333333333334 866.3199999999999 997.3333333333334 816V544H181.3333333333334V272H453.3333333333334V181.3333333333333H90.6666666666667L91.12 816C91.12 866.3199999999999 131.0133333333333 906.6666666666666 181.3333333333334 906.6666666666666H906.6666666666669zM181.3333333333334 816V725.3333333333333H906.6666666666669V816H181.3333333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Payments.displayName = `Blueprint5.Icon.Payments`;
export default Payments;
